import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import ModalConfirmLogout from '../../components/ModalConfirmLogout';
import './FormulaDetail.css';
import { getFormulaById, FormulaDetailData } from './mockApi';


const FormulaDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [formulaData, setFormulaData] = useState<FormulaDetailData | null>(null);
  const [loading, setLoading] = useState(true);
  const [isShowLogout, setIsShowLogout] = useState(false);

  const fetchFormulaDetail = useCallback(async () => {
    try {
      setLoading(true);
      
      // Get formula from mock API
      const formulaId = parseInt(id || '1');
      const formulaData = getFormulaById(formulaId);
      
      if (formulaData) {
        setFormulaData(formulaData);
      } else {
        setFormulaData(null);
      }
    } catch (error) {
      console.error('Error fetching formula detail:', error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchFormulaDetail();
  }, [fetchFormulaDetail]);

  const handleBack = () => {
    navigate('/cong-thuc');
  };

  if (loading) {
    return (
      <div className="formula-detail-page">
        <video 
          className="video-bg hidden sm:block"
          autoPlay 
          muted 
          loop 
          playsInline
        >
          <source src="/assets/bg-pc.mp4" type="video/mp4" />
        </video>
        <video
          className="video-bg block sm:hidden"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/assets/bg-mb.mp4" type="video/mp4" />
        </video>
        <Header setIsShowLogout={() => setIsShowLogout(true)} />
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Đang tải công thức...</p>
        </div>
      </div>
    );
  }

  if (!formulaData) {
    return (
      <div className="formula-detail-page">
        <video 
          className="video-bg hidden sm:block"
          autoPlay 
          muted 
          loop 
          playsInline
        >
          <source src="/assets/bg-pc.mp4" type="video/mp4" />
        </video>
        <video
          className="video-bg block sm:hidden"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/assets/bg-mb.mp4" type="video/mp4" />
        </video>
        <Header setIsShowLogout={() => setIsShowLogout(true)} />
        <div className="error-container">
          <p>Không tìm thấy công thức</p>
          <button onClick={handleBack} className="back-button back-cta">
            <img
              src="/assets/arrow-back.png"
              alt="QUAY LẠI"
              className="back-cta-img"
            />
            <span className="back-cta-text">QUAY LẠI</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="formula-detail-page">
      <video 
        className="video-bg hidden sm:block"
        autoPlay 
        muted 
        loop 
        playsInline
      >
        <source src="/assets/bg-pc.mp4" type="video/mp4" />
      </video>
      <video
        className="video-bg block sm:hidden"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="/assets/bg-mb.mp4" type="video/mp4" />
      </video>
      <Header setIsShowLogout={() => {}} />
      
      <div className="formula-detail-content">
        <div className="formula-header">
          <button onClick={handleBack} className="back-button back-cta">
          <img
            src="/assets/arrow-back.png"
            alt="QUAY LẠI"
            className="back-cta-img"
          />
          <span className="back-cta-text">QUAY LẠI</span>
          </button>
        </div>
        
        <div className="formula-main">
          <div className="formula-title-section">
            <h1 className="formula-title">{formulaData.title}</h1>
            <p className="formula-subtitle">{formulaData.subtitle}</p>
          </div>
          
          <div className="formula-content">
            <div className="content-text">
              {formulaData.content.split('\n').map((line, index) => {
                if (line.includes('![LV2]')) {
                  return <img key={index} src="/assets/lv2.png" alt="LV2" className="content-image" />;
                } else if (line.includes('![LV3-1]')) {
                  return <img key={index} src="/assets/lv3-1.png" alt="LV3-1" className="content-image" />;
                } else if (line.includes('![LV3-2]')) {
                  return <img key={index} src="/assets/lv3-2.png" alt="LV3-2" className="content-image" />;
                } else if (line.includes('![LV5]')) {
                  return <img key={index} src="/assets/lv5.png" alt="LV5" className="content-image" />;
                } else if (line.includes('![LV6]')) {
                  return <img key={index} src="/assets/lv6.png" alt="LV6" className="content-image" />;
                } else if (line.includes('![LV7]')) {
                  return <img key={index} src="/assets/lv7.png" alt="LV7" className="content-image" />;
                } else if (line.includes('![LV8]')) {
                  return <img key={index} src="/assets/lv8.png" alt="LV8" className="content-image" />;
                } else if (line.startsWith('# ')) {
                  return <h1 key={index} className="content-h1">{line.replace('# ', '')}</h1>;
                } else if (line.startsWith('## ')) {
                  return <h2 key={index} className="content-h2">{line.replace('## ', '')}</h2>;
                } else if (line.startsWith('**') && line.endsWith('**')) {
                  return <strong key={index} className="content-bold">{line.replace(/\*\*/g, '')}</strong>;
                } else if (line.trim() === '') {
                  return <br key={index} />;
                } else {
                  return <p key={index} className="content-paragraph">{line}</p>;
                }
              })}
            </div>
          </div>
        </div>
      </div>
      
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => setIsShowLogout(false)}
      />
    </div>
  );
};

export default FormulaDetail;
